<template>
    <div class="part1 part">
        <el-row>
          <el-col :span="4">&nbsp;</el-col>
          <el-col class="left" :span="10">
            <h1>飞鸽，您的网信工作助手</h1>
            <h3>一款为网评工作定制的在线舆论导控、网评员管理指挥和传播力建设系统。</h3>
            <p><span @click="contactUs">联系我们</span></p>
          </el-col>
          <el-col class="right" :span="10">
                <p class="sddz">
                    <span>深度定制</span>
                </p>
                <p class="zncz">
                    <span>智能处置</span>
                </p>
                <p class="wprw">
                    <span>网评任务</span>
                </p>
                <p class="yldk">
                    <span>舆论导控</span>
                </p>
          </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    name :"PartOne",
    data(){
        return{

        }
    },
    methods:{
        contactUs:function(){
          let timer = setInterval(function(){
            if(document.documentElement.scrollTop >= 4990){
              clearTimeout(timer);
            }else{
              document.documentElement.scrollTop +=100;
            }
          },10)
        }
    }
}
</script>
<style scoped>
    /*----------part1 开始--------------*/
  .part1{
    background: url(../../static/images/part1.jpg) no-repeat;
    background-size: 100% 100%;
    color: #fff;
  }
  .part1 .left h1{
    margin:0px;
    margin-top:25%;
  }
  .part1 .left h3{
    width: 80%;
    font-weight: normal;
  }
  .part1 .left p span{
    border: 1px solid #fff;
    padding: 6px 20px;
    border-radius: 4px;
    cursor: pointer;
  }
  .part1 .right{
    /* border: 1px solid red; */
    margin-top: 80px;
    font-weight: bold;
  }
  .part1 .right p{
    width:80px;
  }
  .part1 .right p span{
		opacity: 0;
		position: relative;
	}
	.part1 .right p.sddz span{
		animation: textLeft 0.6s linear forwards;
	}
	.part1 .right p.zncz span{
		animation: textLeft 0.6s linear forwards;
		animation-delay:0.3s;
	}
	.part1 .right p.wprw span{
		animation: textLeft 0.6s linear forwards;
		animation-delay:0.6s;
	}
	.part1 .right p.yldk span{
		animation: textLeft 0.6s linear forwards;
		animation-delay:0.9s;
	}
  /*----------part1 结束--------------*/ 
  /*------------动画---------------*/
  @keyframes textLeft{
		from{
				right: -10px;
				opacity: 0;
		}to{
				right: 0px;
				opacity: 1;
		}
  }
  /*------------动画 end---------------*/
  @media (max-width: 1439px){
    .part1{
      height: 400px;
    } 
    .part1 .left h1{
      font-size: 40px;
      margin-top:25%;
    }
    .part1 .left h3{
      font-size: 16px;
      margin: 10px 0 60px 0;
    }
    .part1 .right p{
      line-height: 80px;
    }
    .part1 .right p.sddz{
      margin-left: 130px;
    }
    .part1 .right p.zncz{
      margin-left: 70px;
    }
    .part1 .right p.wprw{
      margin-left: 30px;
    }
    .part1 .right p.yldk{
      margin-left: 40px;
    }
  }
  @media (min-width: 1440px ) {
    .part1{
      height: 500px;
    } 
    .part1 .left h1{
      font-size: 50px;
    }
    .part1 .left h3{
      font-size: 20px;
      margin: 10px 0 60px 0;
    }
    .part1 .right p{
      font-size: 20px;
      line-height: 100px;
    }
    .part1 .right p.sddz{
      margin-left: 140px;
    }
    .part1 .right p.zncz{
      margin-left: 70px;
    }
    .part1 .right p.wprw{
      margin-left: 25px;
    }
    .part1 .right p.yldk{
      margin-left: 35px;
    }
    
  }
  @media (min-width: 1680px) {
    .part1{
      height: 600px;
    }
    .part1 .left h3{
      font-size: 25px;
      margin: 20px 0 120px 0;
    }
    .part1 .right p{
      font-size: 20px;
      line-height: 120px;
    }
    .part1 .right p.sddz{
      margin-left: 200px;
    }
    .part1 .right p.zncz{
      margin-left: 100px;
    }
    .part1 .right p.wprw{
      margin-left: 30px;
    }
    .part1 .right p.yldk{
      margin-left: 50px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/PartOne.vue